// IMPORTANT: Build gql after ANY changes to queries (client OR api)

import { graphql } from '@/client/services/api/graphql/gql';

export const getWorkflowOverviewTotalsQuery: any = graphql(`
  query GetWorkflowOverviewTotalsQuery {
    workflowOverview {
      automatedWorkflowCount
      directWorkflowCount
      totalWorkflowCount
      __typename
    }
  }
`);
